<template>
  <VVisibilityState
    v-slot="{ visioned }"
    class="w-full grow-0 shrink-0 relative aspect-[3/2]"
    @mouseenter="hovered = true"
    @mouseleave="hovered = false"
  >
    <template v-if="visioned">
      <VProgressiveImage
        :src="mediaDefault.original_url"
        :width="1200"
        :height="800"
        :class="{ '!opacity-0 absolute top-0 left-0': mediaHover && hovered }"
        :alt="product.name"
      />
      <VProgressiveImage
        v-if="mediaHover"
        :src="mediaHover.original_url"
        :width="1200"
        :height="800"
        :class="{ '!opacity-0 absolute top-0 left-0': !hovered }"
        :alt="product.name"
      />
    </template>
  </VVisibilityState>
</template>

<script setup>
import { ref, computed } from 'vue';
import VVisibilityState from '../../../components/state/VVisibilityState.vue';
import VProgressiveImage from '../../../components/common/VProgressiveImage.vue';

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
});

const hovered = ref(false);
const mediaDefault = computed(() => props.product.medias.find((media) => media.collection_name === 'default'));
const mediaHover = computed(() => props.product.medias.find((media) => media.collection_name === 'hover'));
</script>
